import React from 'react';
import { connect } from 'react-redux';
import { Text, i18n, tokens, Modal } from '@simplybenefits/sb-ui-library';

/**
 * @param fixableClaimErrors
 * @param showContinueAnyway
 * @param onClose
 * @param onEdit
 * @param onSave
 * @param loader
 * @returns {JSX.Element}
 * @constructor
 */
const ClaimErrorModal = ({ fixableClaimErrors, showContinueAnyway, onClose, onEdit, onSave, loader }) => (
    <Modal
        open={true}
        onClose={ onClose }
        loader={ loader }
        title={ i18n.t(tokens.labels.claims.confirmContinue) }
        secondaryButton={ showContinueAnyway ?
            {
                label: i18n.t(tokens.buttons.continueAnyway),
                onClick: onSave
            }
            :
            null
        }
        primaryButton={{
            label: i18n.t(tokens.buttons.editSubmission),
            onClick: onEdit
        }}
    >
        {
            fixableClaimErrors.map((error, i) => (
                <Text
                    display="block"
                    medium
                    margin="10px 0px 10px 0px"
                    key={i}
                >
                    { error }
                </Text>
            ))
        }

        {
            Boolean(showContinueAnyway) &&
                <Text
                    display="block"
                    medium
                    margin="20px 0px 0px 0px"
                    light
                >
                    { i18n.t(tokens.labels.claims.quickReimbursementNote) }
                </Text>
        }
    </Modal>
);

export default connect()(ClaimErrorModal);